import { clamp, mapRange } from 'gsap/all';
import { module } from 'modujs';

// All sizes in percents
const LEFT_COL_WIDTH_START = .38;
const LEFT_COL_WIDTH_END = .25;

const FONT_SIZE_START = 50;
const FONT_SIZE_END = 35;

export default class extends module {
    constructor(m) {
        super(m);

        // Binding
        this.onResizeBind = this.onResize.bind(this)

        // UI
        this.$el = this.el
        this.$left = this.$('left')[0]

        this.width = this.$el.offsetWidth; 
    }

    ///////////////
    // Lifecyle
    ///////////////
    init() {
        this.bindEvents();
        this.onResize();

        requestAnimationFrame(() => {
            this.onProgress(0)
        })
    }

    destroy() {
        super.destroy();
        this.unbindEvents();
    }

    ///////////////
    // Events
    ///////////////
    bindEvents() {
        window.addEventListener('resize', this.onResizeBind)
    }

    unbindEvents() {
        window.removeEventListener('resize', this.onResizeBind)
    }

    ///////////////
    // Callbacks
    ///////////////
    onResize() {
        this.width = this.$el.offsetWidth
    }


    onProgress(progress) {
        const leftPercent = clamp(LEFT_COL_WIDTH_END, LEFT_COL_WIDTH_START, mapRange(0, 1, LEFT_COL_WIDTH_START, LEFT_COL_WIDTH_END, progress))
        const fontSize = clamp(FONT_SIZE_END, FONT_SIZE_START, mapRange(0, 1, FONT_SIZE_START, FONT_SIZE_END, progress))

        this.$el.style.setProperty("--left-col-width", `calc(${this.width * leftPercent}px - 1px)`);
        this.$el.style.setProperty("--font-size", `${fontSize}px`);
    }

    forceProgressStart() {
        this.$el.style.setProperty("--left-col-width", `calc(${this.width * LEFT_COL_WIDTH_START}px - 1px)`);
        this.$el.style.setProperty("--font-size", `${FONT_SIZE_START}px`);
    }

    forceProgressEnd() {
        this.$el.style.setProperty("--left-col-width", `calc(${this.width * LEFT_COL_WIDTH_END}px - 1px)`);
        this.$el.style.setProperty("--font-size", `${FONT_SIZE_END}px`);
    }
}